import React, { useState, useRef, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";

import { SearchOutlined } from "@ant-design/icons";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Highlighter from "react-highlight-words";
import Create_icon from "../../assets/images/create_icon.png";
import UnionIcon from "../../assets/images/icons/Union_5.svg";
import infoIcons from "../../assets/images/info_icon.png";
import Edit_icon from "../../assets/images/icons/edit_icon.svg";
import Delete_iconbl from "../../assets/images/icons/delete_iconbl.svg";
import CatalogJewelryDataService from "../../services/catalog-jewelry.service";
import LoginDataService from "../../services/login.service";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  Button,
  Col,
  Empty,
  Input,
  Modal,
  Radio,
  Select,
  Space,
  Spin,
  Switch,
  Table,
  Tooltip,
} from "antd";

import {
  setSelectSideMenu,
  setEditCollectionTierMenu,
} from "../../actions/headerMenu/headerMenu";
import communityVendorService from "../../services/community-vendor.service";
import StarRatings from "react-star-ratings";

const { Option } = Select;

export const ManageCollection = (props) => {
  const { t } = useTranslation();
  const { Search } = Input;
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [loading, setLoading] = useState(false);
  const [filterValue, setFilterValue] = useState("All");
  const [allFilterValue, setAllFilterValue] = useState("");
  const [collectionList, setCollectionList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [delConsoleData, setDelConsoleData] = useState({
    collectionID: "",
  });
  const [disableBtn, setDisableBtn] = useState(true);
  const [dealerMemberTypeName, setDealerMemberTypeName] = useState("");
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [collectionText, setCollectionText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [isFilter, setIsFilter] = useState(false);
  const [dealerId, setDealerId] = useState(0);
  const [collectionDrpList, setCollectionDrpList] = useState([]);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);

  const [sortColumnName, setSortColumnName] = useState("collection");
  const [sortType, setSortType] = useState("asc");
  const [activeExpRow, setActiveExpRow] = useState();
  const [image, setImage] = useState("");
  const [isImageModal, setIsImageModal] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const [selectedColumnId, setSelectedColumnId] = useState(0);
  const [rowDetails, setRowDetails] = useState([]);
  const [rowCollection, setRowCollection] = useState();
  const [indexingStatus, setIndexingStatus] = useState("");

  const selectedDesignerName = localStorage.getItem("vendorDataForCollection");

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          // Get vendor name from query params or localStorage
          const vendorName = searchParams.get('designerName') || selectedDesignerName || "";
          handleGetCollectionsList(
            loginDetials.loginDetials.responseData.dealerId,
            pageNo,
            pageSize,
            "collection",
            "asc",
            filterValue,
            vendorName
          );
          handleGetBrandListbyDealer(
            loginDetials.loginDetials.responseData.dealerId
          );
          setDealerMemberTypeName(
            loginDetials.loginDetials.responseData.dealerMemberTypeName
          );
          // Fetch indexing status on page load
          fetchIndexingStatus(loginDetials.loginDetials.responseData.dealerId);
        }
      }
    }
  }, []);

  // Function to fetch indexing status
  const fetchIndexingStatus = async (id) => {
    try {
      const response = await LoginDataService.GetIndexingStatus({
        dealerId: id,
      });
      if (response.data && response.data.responseData) {
        setIndexingStatus(response.data.responseData.indexingStatus || "");
      }
    } catch (error) {
      console.log("Error fetching indexing status:", error);
    }
  };

  useEffect(() => {
    if (filterValue === "HomeOnly") {
      setAllFilterValue("");
    }
    if (filterValue === "VendorExtension") {
      setAllFilterValue("");
    }
  });

  const handleApplyFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setFilterValue(filterValue);
    setAllFilterValue(allFilterValue);
    handleGetCollectionsList(
      dealerId,
      pageNo,
      pageSize,
      sortColumnName,
      sortType,
      filterValue,
      allFilterValue
    );
  };

  function getColumnSearchProps(dataIndex) {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            ref={searchInput}
            placeholder={t("Search..")}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              {t("Search")}
            </Button>
            <Button
              onClick={() => handleReset(clearFilters, confirm)}
              size="small"
              style={{ width: 90 }}
            >
              {t("Reset")}
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          .toString()
          .toLowerCase()

          .includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: (visible) => {},
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        ),
    };
  }

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  }

  function handleReset(clearFilters, confirm) {
    clearFilters();
    setSearchText("");
    confirm();
  }

  const handleGetBrandListbyDealer = (id) => {
    let inputData = {
      dealerID: id,
    };
    setLoading(true);
    CatalogJewelryDataService.GetBrandListbyDealer(inputData)
      .then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          setBrandList(responseData);
          // Prioritize query params over localStorage
          const vendorName = searchParams.get('designerName') || selectedDesignerName;
          setAllFilterValue(vendorName);
        } else {
          setBrandList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleGetCollectionsCount = (id) => {
    let inputData = {
      dealerID: id,
    };

    CatalogJewelryDataService.GetCollectionsCount(inputData)
      .then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData.collectionsCount;

        if (message === "Success") {
          setCollectionDrpList(responseData);
        } else {
          setCollectionDrpList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleGetCollectionsList = async (
    id,
    pageNo,
    pageSize,
    sortColumnName,
    sortType,
    filterValue,
    allFilterValue,
    filters,
    searchVal
  ) => {
    let inputData = {
      dealerID: id,
      collectionType: filterValue,
      brandID: 0,
      sortBy: allFilterValue
        ? allFilterValue
        : selectedDesignerName
        ? selectedDesignerName
        : "",
      pageNumber: pageNo,
      pageSize: pageSize,
      sortColName: sortColumnName || "collection",
      sortOrder: sortType || "ASC",
      searchBy: filters
        ? filters
        : selectedDesignerName
        ? selectedDesignerName
        : "",
      role: loginDetials.loginDetials.responseData.dealerMemberTypeName.toString(),
    };
    setLoading(true);
    if (filterValue === "All" || filterValue == "Vendor") {
      setIsFilter(false);
    } else {
      setIsFilter(true);
    }
    localStorage.removeItem("vendorDataForCollection");
    CatalogJewelryDataService.GetCollectionsList(inputData)
      .then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          let data = responseData;
          if (searchVal !== "" && searchVal !== undefined) {
            let filteredData = data
              ?.filter((item) =>
                item?.brandName
                  ?.toString()
                  .toLowerCase()
                  .includes(searchVal?.toLowerCase())
              )
              .map((item) => item);
            setCollectionList(filteredData);
            handleShowDataToRightNewCollection(filteredData[0]);
          } else {
            setCollectionList(data);
            handleShowDataToRightNewCollection(data[0]);
          }
          handleGetCollectionsCount(id);
          setDisableBtn(true);
        } else {
          setCollectionList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleShowDataToRightNewCollection = (record) => {
    let inputData = {
      collectionID: record.collectionID.toString(),
    };
    setRowCollection(record);
    setSelectedColumnId(record.collectionID);
    CatalogJewelryDataService.GetCollectionStatusById(inputData)
      .then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData[0];
        if (message === "Success") {
          if (responseData) {
            handleShowDataToRightNew(
              responseData?.dealerID,
              responseData?.collection
            );
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };

  const handleShowDataToRightNew = (id, collection) => {
    let inputData = {
      vendorID: id.toString(),
      dealerID: "",
      f_Type: "1",
      isEnable: "true",
    };

    communityVendorService
      .ShowDataToRightNew(inputData)
      .then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData[0];
        if (message === "Success") {
          if (responseData) {
            setRowDetails(responseData);
            setCollectionText(collection);
          } else {
            setRowDetails({});
            setCollectionText("");
          }
        } else {
          setRowDetails({});
          setCollectionText("");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };
  console.log(rowDetails, "rowDetails");

  const handleDeleteModal = (row) => {
    setIsModalVisible(true);
    setDelConsoleData({
      collectionID: row.collectionID,
    });
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setDelConsoleData({});
  };

  const DeleteConsoleUploadData = () => {
    let inputData = {
      collectionID: parseInt(delConsoleData.collectionID),
      dealerID: dealerId.toString(),
    };

    CatalogJewelryDataService.DeleteCollectionStatusById(inputData)
      .then((response) => {
        let message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Record Deleted Successfully."));
          handleGetCollectionsList(
            dealerId,
            pageNo,
            pageSize,
            sortColumnName,
            sortType,
            filterValue,
            allFilterValue
          );
        } else {
          NotificationManager.error(t("Record Not Deleted."));
        }
      })
      .catch((error) => {
        console.log(error);
      });
    handleCancel();
  };

  const handleIsSelectChange = (saveRow) => {
    let inputData = {
      collectionID: parseInt(saveRow.collectionID),
      // dealerID: parseInt(saveRow.dealerID),
      dealerID: parseInt(dealerId),
      status: parseInt(saveRow.isSelected === false ? 0 : 1),
    };
    CatalogJewelryDataService.UpdateVisibleStatus(inputData)
      .then((response) => {
        let message = response.data.message;

        if (message === "Success") {
          NotificationManager.success(t("Record Updated Successfully."));
          handleGetCollectionsList(
            dealerId,
            pageNo,
            pageSize,
            sortColumnName,
            sortType,
            filterValue,
            allFilterValue
          );
          // Fetch indexing status after visibility change
          fetchIndexingStatus(dealerId);
        } else {
          NotificationManager.error(t("Record Not Updated."));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCollectionVendorEnable = (saveRow) => {
    let inputData = {
      collectionID: parseInt(saveRow.collectionID),
      retailerID: parseInt(saveRow.dealerID),
      enable: !saveRow.enabled_ ? 0 : 1,
    };
    CatalogJewelryDataService.ChangeCollectionVendorEnable(inputData)
      .then((response) => {
        let message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Record Updated Successfully."));
          handleGetCollectionsList(
            dealerId,
            pageNo,
            pageSize,
            sortColumnName,
            sortType,
            filterValue,
            allFilterValue
          );
        } else {
          NotificationManager.error(t("Record Not Updated."));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlePricingVendorChange = (saveRow) => {
    let inputData = {
      collectionID: parseInt(saveRow.collectionID),
      retailerID: parseInt(dealerId),
      dealerID: String(saveRow.dealerID) || "",
      override: parseInt(
        !saveRow.overrideEnabled
          ? 0
          : saveRow.markupOverride
          ? saveRow.markupOverride
          : saveRow.override
      ),
      pricing: parseInt(saveRow.pricing === false ? 0 : 1),
      overrideValue: saveRow.overrideEnabled === false ? "0" : "1",
    };
    CatalogJewelryDataService.ChangeCollectionVendorPricing(inputData)
      .then((response) => {
        let message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Record Updated Successfully."));
          handleGetCollectionsList(
            dealerId,
            pageNo,
            pageSize,
            sortColumnName,
            sortType,
            filterValue,
            allFilterValue
          );
        } else {
          NotificationManager.error(t("Record Not Updated."));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOnChange = (row, e, name) => {
    if (name === "isSelected") {
      const temp = collectionList.map((x) => {
        if (x.collectionID === row.collectionID) {
          return { ...x, isSelected: e };
        } else return x;
      });
      let saveRow = temp.filter(
        (obj) => obj.collectionID == row.collectionID
      )[0];
      setCollectionList(temp);
      handleIsSelectChange(saveRow);
    }
    if (name === "pricing") {
      const temp = collectionList.map((x) => {
        if (x.collectionID === row.collectionID) {
          return { ...x, pricing: e };
        } else return x;
      });
      let saveRow = temp.filter(
        (obj) => obj.collectionID == row.collectionID
      )[0];
      setCollectionList(temp);
      handlePricingVendorChange(saveRow);
    }
    if (name === "enabled") {
      const temp = collectionList.map((x) => {
        if (x.collectionID == row.collectionID) {
          return { ...x, enabled_: e };
        } else return x;
      });
      let saveRow = temp.filter(
        (obj) => obj.collectionID == row.collectionID
      )[0];
      setCollectionList(temp);
      handleCollectionVendorEnable(saveRow);
    }
    if (name === "overrideEnabled") {
      const temp = collectionList.map((x) => {
        if (x.collectionID === row.collectionID) {
          return {
            ...x,
            overrideEnabled: e.target.value === "percentage",
          };
        } else return x;
      });
      let saveRow = temp.filter(
        (obj) => obj.collectionID == row.collectionID
      )[0];
      setCollectionList(temp);
      setRowCollection(saveRow);
    }
    if (name === "markupOverride") {
      if (Number(e.target.value) >= 0 && Number(e.target.value) <= 1000) {
        const temp = collectionList.map((x) => {
          if (x.collectionID === row.collectionID) {
            return {
              ...x,
              markupOverride: e.target.value,
            };
          } else return x;
        });
        let saveRow = temp.filter(
          (obj) => obj.collectionID == row.collectionID
        )[0];
        setCollectionList(temp);
        setRowCollection(saveRow);
      } else {
        e.preventDefault();
      }
    }
  };

  const onKeyPressEvent = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!new RegExp("[0-9]").test(keyValue)) event.preventDefault();
    return;
  };

  const handleOnSelectChange = (e, name) => {
    setDisableBtn(false);
    if (name == "filterValue") {
      setFilterValue(e);
    }
    if (name == "allFilterValue") {
      setAllFilterValue(e);
    }
  };

  const modifiedData = collectionList.map((item) => ({
    ...item,
    key: item.collectionID,
  }));

  const handleOpenImageModal = (row) => {
    setImage(row.collectionImage);
    setIsImageModal(true);
  };

  const handleCloseImageModal = (row) => {
    setImage("");
    setIsImageModal(false);
  };

  const handleEditRedirect = (id, value) => {
    dispatch(setEditCollectionTierMenu("true"));
    dispatch(setSelectSideMenu(["editCollection"]));
    navigate("/editCollection", { state: { key: id, filterVal: value } });
  };

  const openInNewTab = (Url) => {
    let url = Url;
    if (Url.includes("https")) {
      window.open(url, "_blank");
    } else if (Url.includes("http")) {
      window.open(url, "_blank");
    } else {
      window.open("https://" + url, "_blank");
    }
  };

  return (
    <div className="form__fields">
      <div className="row magento__mapping permission__section">
        <div className="col-md-12">
          <div className="heading__block mb-3">
            <h4 className="workarea__heading mt-0 mb-0">
              {t("Manage Collection")}
              {"(" + collectionList.length + ")"}
              {indexingStatus === "InProcess" && (
                <Tooltip title={t("Indexing in progress")}>
                  <span className="indexing-symbol ml-2" style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "20px",
                    height: "20px",
                    backgroundColor: "#1883b8",
                    color: "#fff",
                    borderRadius: "50%",
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginLeft: "8px"
                  }}>
                    i
                  </span>
                </Tooltip>
              )}
            </h4>
            <div className="d-flex">
              <button
                style={{ flex: "none" }}
                className="primary-btn d-flex  align-items-center sm_mr "
              >
                {" "}
                <img src={Create_icon} alt="" />{" "}
                <Link to={"/addCollection"} className="manage__Link">
                  {t("Create Collection")}
                </Link>
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="row">
            <div
              className={
                dealerMemberTypeName != "Vendor" ? "input__block col-md-3" : ""
              }
            >
              {dealerMemberTypeName != "Vendor" ? (
                <Select
                  name="filterValue"
                  placeholder={t("Select Collections")}
                  optionFilterProp="children"
                  className="border__grey"
                  onChange={(e) => handleOnSelectChange(e, "filterValue")}
                  value={filterValue}
                >
                  {collectionDrpList?.map((item) => {
                    return (
                      <Option value={item.collectionID}>
                        {item.collectionCount}
                      </Option>
                    );
                  })}
                </Select>
              ) : null}
            </div>
            {(filterValue === "All") | (filterValue === "Vendor") &&
            dealerMemberTypeName != "Vendor" ? (
              <div
                className={
                  (filterValue === "All") | (filterValue === "Vendor") &&
                  dealerMemberTypeName != "Vendor"
                    ? "input__block col-md-3"
                    : ""
                }
              >
                <Select
                  name="allFilterValue"
                  optionFilterProp="children"
                  placeholder={t("Select Vendor")}
                  className="border__grey"
                  onChange={(e) => handleOnSelectChange(e, "allFilterValue")}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={allFilterValue}
                >
                  <Option value=""> {t("All Vendors")} </Option>
                  {brandList.map((item) => {
                    return (
                      <Option key={item.designerName} value={item.designerName}>
                        {item.designerName}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            ) : null}
            <div
              className={
                dealerMemberTypeName != "Vendor"
                  ? "col-md-4 aplyfilt__btndiv"
                  : ""
              }
            >
              {dealerMemberTypeName != "Vendor" ? (
                <button
                  className={disableBtn ? "disabled-btn" : "primary-btn"}
                  disabled={disableBtn}
                  onClick={handleApplyFilters}
                >
                  {" "}
                  <i className="fa fa-search"></i> {t("Apply Filter")}
                </button>
              ) : null}
            </div>
          </div>
        </div>
        <div
          className={
            selectedColumnId !== 0
              ? "col-lg-9 divForm vendors-section"
              : "col-lg-12"
          }
        >
          <div
            className={
              dealerMemberTypeName != "Vendor" ? "divForm row" : "divForm"
            }
          >
            <Spin spinning={loading} size="large">
              <div className="table__scroll mobile__topspace">
                <Table
                  key={tableKey}
                  dataSource={modifiedData}
                  pagination={{
                    size: "small",
                    showSizeChanger: true,
                    responsive: true,
                  }}
                  className="vdiamond__table"
                  columns={[
                    {
                      title: (
                        <Tooltip title={t("Collection Name")}>
                          {t("Collection Name")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "collection",
                      sorter: (a, b) =>
                        a.collection.localeCompare(b.collection),
                      showSorterTooltip: false,
                      render: (index, row) => (
                        <span className="linkText">{row.collection}</span>
                      ),
                    },

                    {
                      title:
                        dealerMemberTypeName == "Vendor"
                          ? t("Brand Name")
                          : t("Vendor"),
                      dataIndex: "brandName",
                      // ...getColumnSearchProps("brandName"),
                      key: "brandName",
                      sorter: (a, b) => a.brandName.localeCompare(b.brandName),
                      showSorterTooltip: false,
                    },

                    ...(dealerMemberTypeName == "Vendor"
                      ? [
                          {
                            title: (
                              <Tooltip title={t("Category")}>
                                {t("Category")}
                              </Tooltip>
                            ),
                            ellipsis: true,
                            dataIndex: "collectionCategory",
                            showSorterTooltip: false,
                            sorter: (a, b) => {},
                            //
                            sorter: (a, b) =>
                              a.collectionCategory.localeCompare(
                                b.collectionCategory
                              ),
                            render: (index, row) => (
                              <span>{row.collectionCategory}</span>
                            ),
                          },
                        ]
                      : []),

                    ...(dealerMemberTypeName != "Vendor"
                      ? [
                          {
                            title: (
                              <Tooltip title={t("Override")}>
                                {t("Override")}
                              </Tooltip>
                            ),
                            ellipsis: true,
                            dataIndex: "override",
                            key: "override",
                            showSorterTooltip: false,
                            sorter: (a, b) => a.override - b.override,
                            render: (index, row) => (
                              <span>
                                {row.overrideEnabled == false
                                  ? "Disabled"
                                  : row.override + "%"}
                              </span>
                            ),
                          },
                        ]
                      : []),
                    {
                      title: <Tooltip title={t("Items")}>{t("Items")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "items",
                      sorter: (a, b) => a.items - b.items,
                      showSorterTooltip: false,
                    },
                    {
                      title: (
                        <Tooltip title={t("Pricing")}>{t("Pricing")}</Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "pricing",
                      render: (item, row) => (
                        <div className="action__btns">
                          <Switch
                            name="pricing"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={row.pricing}
                            onChange={(e) => handleOnChange(row, e, "pricing")}
                          />
                        </div>
                      ),
                    },

                    {
                      title: (
                        <span className="font__bold d-flex">
                          {t("Visibility")}
                          {dealerMemberTypeName == "Retailer" ||
                          dealerMemberTypeName == "Admin" ? null : (
                            <Tooltip
                              placement="right"
                              className="ml-1"
                              title={t(
                                "This shows the collection on your own MasterLink, for preview purposes"
                              )}
                            >
                              <img  src={infoIcons} alt=""  />
                            </Tooltip>
                          )}
                        </span>
                      ),
                      dataIndex: "isSelected",
                      render: (item, row) => (
                        <div className="action__btns">
                          <Switch
                            name="isSelected"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={row.isSelected}
                            onChange={(e) =>
                              handleOnChange(row, e, "isSelected")
                            }
                          />
                        </div>
                      ),
                    },
                    ...(dealerMemberTypeName == "Vendor"
                      ? [
                          {
                            title: (
                              <span
                                className={
                                  dealerMemberTypeName == "Vendor"
                                    ? "d-flex font__bold"
                                    : ""
                                }
                              >
                                {t("Enabled")}
                                <Tooltip
                                  placement="right"
                                  className="ml-1"
                                  title={t(
                                    "This shares the collection with your connected retailers"
                                  )}
                                >
                                  <img src={infoIcons} alt="" />
                                </Tooltip>
                              </span>
                            ),
                            dataIndex: "enabled_",
                            render: (item, row) => (
                              <div className="action__btns">
                                <Switch
                                  name="enabled"
                                  checkedChildren={t("Yes")}
                                  unCheckedChildren={t("No")}
                                  checked={row.enabled_ == true ? true : false}
                                  onChange={(e) =>
                                    handleOnChange(row, e, "enabled")
                                  }
                                />
                              </div>
                            ),
                          },
                        ]
                      : []),
                    ...(dealerMemberTypeName == "Vendor" &&
                    filterValue == "All" &&
                    !isFilter
                      ? [
                          {
                            title: (
                              <Tooltip title={t("Action")}>
                                {t("Action")}
                              </Tooltip>
                            ),
                            ellipsis: true,
                            render: (index, row) => (
                              <div className="action__btns">
                                <div className="image__block">
                                  <div
                                    onClick={() =>
                                      handleEditRedirect(
                                        row.collectionID,
                                        filterValue
                                      )
                                    }
                                  >
                                    <img src={Edit_icon} alt="" />
                                  </div>
                                </div>
                                <div className="image__block">
                                  <img
                                    src={Delete_iconbl}
                                    onClick={() => {
                                      handleDeleteModal(row);
                                    }}
                                    alt=""
                                  />
                                </div>
                              </div>
                            ),
                          },
                        ]
                      : filterValue == "HomeOnly" && isFilter
                      ? [
                          {
                            title: (
                              <Tooltip title={t("Action")}>
                                {t("Action")}
                              </Tooltip>
                            ),
                            ellipsis: true,
                            render: (index, row) => (
                              <div className="action__btns">
                                <div className="image__block">
                                  <div
                                    onClick={() =>
                                      handleEditRedirect(
                                        row.collectionID,
                                        filterValue
                                      )
                                    }
                                  >
                                    <img src={Edit_icon} alt="" />
                                  </div>
                                </div>
                                <div className="image__block">
                                  <img
                                    src={Delete_iconbl}
                                    onClick={() => {
                                      handleDeleteModal(row);
                                    }}
                                    alt=""
                                  />
                                </div>
                              </div>
                            ),
                          },
                        ]
                      : isFilter
                      ? [
                          {
                            title: (
                              <Tooltip title={t("Action")}>
                                {t("Action")}
                              </Tooltip>
                            ),
                            ellipsis: true,
                            render: (index, row) => (
                              <div className="action__btns">
                                <div className="image__block">
                                  <div
                                    onClick={() =>
                                      handleEditRedirect(
                                        row.collectionID,
                                        filterValue
                                      )
                                    }
                                  >
                                    <img src={Edit_icon} alt="" />
                                  </div>
                                </div>
                                <div className="image__block">
                                  <img
                                    src={Delete_iconbl}
                                    onClick={() => {
                                      handleDeleteModal(row);
                                    }}
                                    alt=""
                                  />
                                </div>
                              </div>
                            ),
                          },
                        ]
                      : filterValue == "All" &&
                        !isFilter &&
                        dealerMemberTypeName !== "Vendor"
                      ? []
                      : filterValue == "Vendor" && isFilter
                      ? []
                      : filterValue == "VendorExtension" && isFilter
                      ? []
                      : []),
                  ]}
                  onRow={(record, recordIndex) => ({
                    onClick: (event) => {
                      handleShowDataToRightNewCollection(record);
                    },
                  })}
                  rowClassName={(record) =>
                    record.collectionID == selectedColumnId ? "row-active" : ""
                  }
                  onChange={(pagination, filters, sorters) => {
                    var contentArea = document.getElementsByClassName("content__area")[0];
                    if (contentArea) contentArea.scrollTop = 0;
                    var antTableContent = document.querySelector(".ant-table-content");
                    if (antTableContent) antTableContent.scrollTop = 0;
                    var antTableBody = document.querySelector(".ant-table-body");
                    if (antTableBody) antTableBody.scrollTop = 0;
                  }}
                />
              </div>
            </Spin>
          </div>
        </div>
        {selectedColumnId !== 0 ? (
          <div className="col-lg-3 col-md-3">
            <div className="right__section">
              <div className="profile__block">
                <Link
                  to={"/vendorProfile"}
                  state={{
                    key: "Profile",
                    id: selectedColumnId,
                  }}
                >
                  <span className="linkText">
                    {rowDetails.designerName ? rowDetails.designerName : null}
                  </span>
                </Link>
                <div className="logoImg__block p-0">
                  <img src={rowDetails.src ? rowDetails.src : null} />
                </div>
                <p className="activeFrom">
                  {" "}
                  {rowDetails.vendorStatus
                    ? rowDetails.vendorStatus
                    : null} | {rowDetails.activity
                      ? rowDetails.activity.split(' @ ')[0]
                        ? moment(rowDetails.activity.split(' @ ')[0], 'DD/MM/YYYY').format('MM/DD/YYYY') + ' @ ' + rowDetails.activity.split(' @ ')[1]
                        : rowDetails.activity
                      : null}{" "}
                </p>

                <div className="star-ratings mb-2">
                  <p className="mb-0"> {t("Data Ratings")} </p>
                  <StarRatings
                    rating={rowDetails.ratingCount}
                    starRatedColor="#1883b8"
                    starDimension="18px"
                    starSpacing="0px"
                    numberOfStars={5}
                  />
                </div>
              </div>

              {dealerMemberTypeName != "Vendor" && (
              <div className="links__block">
                <ul>
                  <li>
                    <Link
                      to={"/vendorProfile?isShow=true"}
                      state={{
                        key: "Profile",
                        id: rowCollection?.dealerID,
                        checkOutOfNetwork: false,
                      }}
                    >
                      <i class="fa fa-address-book-o" aria-hidden="true"></i>{" "}
                      {t("View Profile")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      to={"/allProducts"}
                      state={{
                        key: "collection",
                        id: collectionText,
                      }}
                    >
                      <i class="fa fa-th-large" aria-hidden="true"></i>{" "}
                      {t("Products")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      to={"/vendorProfile?isShow=true"}
                      state={{
                        key: "Conversation",
                        id: rowCollection?.dealerID,
                        checkOutOfNetwork: false,
                      }}
                    >
                      <i class="fa fa-comments-o" aria-hidden="true"></i>{" "}
                      {t("Conversation")}
                    </Link>
                  </li>
                  {window.location.pathname !== "/outOfNetwork" && (
                    <>
                      {rowDetails.vendorStatus !== "Out of Network" &&
                      rowDetails.vendorStatus !== "Profile Only" ? (
                        <li>
                          <Link
                            to={"/vendorProfile?isShow=true"}
                            state={{
                              key: "Inventory",
                              id: rowCollection?.dealerID,
                              checkOutOfNetwork: false,
                              bindActivePageName:
                                props?.type == "Popular"
                                  ? "Popular"
                                  : props?.type == "Recently Updated"
                                  ? "Recently Updated"
                                  : props?.type == "Archived Vendor"
                                  ? "Archived Vendor"
                                  : props?.type == "New"
                                  ? "New"
                                  : props?.type == "Pending Requests"
                                  ? "Pending Requests"
                                  : props?.type == "Out Of Network"
                                  ? "Out Of Network"
                                  : "Network",
                            }}
                          >
                            <i class="fa fa-diamond" aria-hidden="true"></i>{" "}
                            {rowDetails.isEnable == "true"
                              ? t("Manage Inventory")
                              : t("View Inventory")}
                          </Link>
                        </li>
                      ) : null}
                    </>
                  )}

                  <li>
                    <Link
                      to={"/vendorProfile?isShow=true"}
                      state={{
                        key: "Location",
                        id: rowCollection?.dealerID,
                        checkOutOfNetwork: false,
                      }}
                    >
                      <i class="fa fa-globe" aria-hidden="true"></i>{" "}
                      {t("View Location")}
                    </Link>
                    <a href="#"></a>
                  </li>
                </ul>
                <hr />
              </div>
              )}
              <p className="mb-2">
                <label className="fontSize_12px">{t("Updated Date")} : </label>
                <span className="mx-2">
                  {moment(rowDetails.lastUpdatedDate).format("MM/DD/YYYY")}
                </span>
              </p>
              {dealerMemberTypeName != "Vendor" ? (
                <>
                  <label className="fontSize_12px">
                    {t("MarkUp Overrride")} :{" "}
                  </label>
                  <div className="d-flex">
                    <div className="radio__block mx-2">
                      <Radio
                        checked={rowCollection.overrideEnabled == false}
                        onChange={(e) =>
                          handleOnChange(rowCollection, e, "overrideEnabled")
                        }
                        value="disabled"
                        option="Disable"
                      >
                        {t("Disable")}
                      </Radio>
                    </div>
                    <div className="radio__block">
                      <Radio
                        checked={rowCollection.overrideEnabled == true}
                        onChange={(e) =>
                          handleOnChange(rowCollection, e, "overrideEnabled")
                        }
                        value="percentage"
                        option="Percentage"
                      >
                        {t("Percent")}
                      </Radio>
                    </div>
                  </div>

                  <div className="input__block mb-2">
                    <div className="input__conten d-flex">
                      <input
                        type="text"
                        onKeyPress={onKeyPressEvent}
                        step="1"
                        min="0"
                        max="100"
                        disabled={
                          rowCollection.overrideEnabled == false ? true : false
                        }
                        onChange={(e) => {
                          e.target.value = e.target.value.slice(0, 3);
                          handleOnChange(rowCollection, e, "markupOverride");
                        }}
                        style={{ width: "80px" }}
                        value={
                          rowCollection.overrideEnabled == false
                            ? ""
                            : rowCollection.markupOverride === undefined
                            ? rowCollection.override
                            : rowCollection.markupOverride !== "" ||
                              rowCollection.markupOverride === ""
                            ? rowCollection.markupOverride
                            : rowCollection.override
                        }
                        className={
                          rowCollection.overrideEnabled == false ? "disabled" : ""
                        }
                      />
                      <span className="ml-1 mr-2 mt-2">%</span>
                      <div className="">
                        <div className="save__btn">
                          <Button
                            onClick={() => {
                              handlePricingVendorChange(rowCollection);
                            }}
                          >
                            {t("Save")}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              <div className="retailer__dtls mb-4">
                <p> {rowDetails.dealerName ? rowDetails.dealerName : null} </p>
                <a href={`mailto:${rowDetails.designerEmail}`}>
                  {" "}
                  {rowDetails.designerEmail
                    ? rowDetails.designerEmail
                    : null}{" "}
                </a>
                <p>
                  {" "}
                  {rowDetails.dealerPhone ? rowDetails.dealerPhone : null}{" "}
                </p>
                <span className="linkText" onClick={() => openInNewTab()}>
                  {" "}
                  {rowDetails.website}
                </span>
                <hr />
              </div>
            </div>
          </div>
        ) : null}

        <Modal
          title={t("Delete Collection")}
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="back" onClick={handleCancel}>
              {t("Cancel")}
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={DeleteConsoleUploadData}
            >
              {t("Delete")}
            </Button>,
          ]}
        >
          {t("Are you sure , you want to delete this Collection?")}
        </Modal>
        <Modal
          title={t("Image")}
          className="modalvdiamond__section"
          centered
          visible={isImageModal}
          onOk={handleCloseImageModal}
          onCancel={handleCloseImageModal}
          footer={[
            <Button
              key="back"
              className="primary-btn"
              onClick={handleCloseImageModal}
            >
              {t("Cancel")}
            </Button>,
          ]}
        >
          {image == "" ? (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          ) : (
            <img style={{ width: "100%" }} src={image} alt="" />
          )}
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ManageCollection);
